<template>
    <div class="bg-white py-16 sm:py-24">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="mx-auto max-w-2xl text-center">
                <span
                    class="inline-flex items-center gap-2 rounded-full bg-secondary-50 px-4 py-1.5 text-sm font-semibold text-secondary-700 ring-1 ring-secondary-600/10">Programs</span>
                <p class="mt-4 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
                    Courses to match your needs
                </p>
                <p class="mt-4 text-slate-500">
                    You can choose from a variety of Arabic courses that suit your needs and interests. Whether you are
                    a beginner or an advanced learner, we have the right course for you.
                </p>
            </div>

            <div class="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-6 sm:mt-16 sm:grid-cols-2 lg:max-w-none lg:grid-cols-4">
                <a :href="`/courses/${course.slug}`" v-for="(course, index) in courses" :key="index"
                    class="group overflow-hidden rounded-2xl bg-white ring-1 ring-slate-900/5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                    <div class="aspect-4/3 overflow-hidden">
                        <img :src="images[index % images.length].src" :alt="course.name"
                            class="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105" />
                    </div>
                    <div class="p-5">
                        <h3 class="font-semibold text-slate-900">{{ course.name }}</h3>
                        <p class="mt-2 text-sm text-slate-500">{{ course.description.substring(0, 70) }}...</p>
                        <span
                            class="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all">
                            View course
                            <ArrowRightIcon class="size-4" aria-hidden="true" />
                        </span>
                    </div>
                </a>
                <a href="/courses"
                    class="group flex flex-col items-center justify-center gap-3 rounded-2xl bg-primary-50 p-8 text-center ring-1 ring-primary-600/10 transition-all duration-300 hover:-translate-y-1 hover:bg-primary-100">
                    <span class="flex size-12 items-center justify-center rounded-xl bg-white text-primary-600 shadow-sm">
                        <ArrowRightIcon class="size-5" aria-hidden="true" />
                    </span>
                    <span class="font-semibold text-primary-700">See all courses</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup type="module">
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { ArrowRightIcon } from '@heroicons/vue/24/outline';
import { getFeaturedProducts } from '@/services/productService';

const courses = ref([]);

const images = [
    {
        alt: 'Arabic Without borders',
        src: 'images/courses/quran.jpg',
    },
    {
        alt: 'Arabic Without borders',
        src: 'images/courses/tafl.jpg',
    },
    {
        alt: 'Arabic Without borders',
        src: 'images/courses/arabic.jpg',
    },
    {
        alt: 'Arabic Without borders',
        src: 'images/courses/islamic.jpg',
    },
];

onMounted(() => {
    getFeaturedProducts().then((response) => {
        courses.value = response.data;
    }).catch((error) => {
        console.error('Error fetching featured courses:', error);
    });
});
</script>
